import React from 'react';
import * as SettingsGlobalPanelEntry from './settings-global-panels';

const componentKeys = Object.keys(SettingsGlobalPanelEntry);

export const SettingsGlobalPanelManager = React.memo(() => {
  return (
    <>
      {componentKeys.map((key) => {
        const Component = SettingsGlobalPanelEntry[key as keyof typeof SettingsGlobalPanelEntry];
        return <Component key={key} />;
      })}
    </>
  );
});

SettingsGlobalPanelManager.displayName = 'SettingsGlobalPanelManager';
